import { useContext } from 'react'
import { FileuploadPickerContext } from './FileuploadPickerContext'

export const useFileuploadPickerContext = () => {
  const context = useContext(FileuploadPickerContext)
  if (!context) {
    throw new Error(
      'useFileuploadPickerContext must be used within a FileuploadPickerProvider'
    )
  }
  return context
}
